module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-copy-cals text-dark"
  }, [_c('div', {
    staticClass: "d-acc",
    class: {
      'd-acc--open': _vm.isAccOpen
    }
  }, [_c('div', {
    staticClass: "d-acc__header",
    on: {
      "click": _vm.toggleIsAccOpen
    }
  }, [_c('div', {
    staticClass: "d-acc__header__left"
  }, [_c('div', {
    staticClass: "d-toggle-arrow",
    class: {
      'd-toggle-arrow--open': _vm.isAccOpen
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchivedWithoutFilters.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
    staticClass: "d-copy-cals__list"
  }, [(_vm.calType === 'user') ? _c('li', {
    staticClass: "select-all-item d-copy-cals__list__header select-all-item d-copy-cals__list__header__filters"
  }, [_c('TaggingFilter', {
    attrs: {
      "schoolid": _vm.schoolId,
      "showHowMany": false,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "set": _vm.setTagFromFilter,
      "remove": _vm.removeTagFromFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "select-all-item d-copy-cals__list__header"
  }, [_c('p', {
    staticClass: "d-acc__header__select-all",
    on: {
      "click": _vm.toggleAllKlasses
    }
  }, [(_vm.selectedCalIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('div', {
    staticClass: "d-copy-cals__list__header__right"
  }, [_c('p', [_vm._v(_vm._s(_vm.selectedCalIds.length) + " " + _vm._s(_vm.$t('vue2.calendars.selected_of')) + " " + _vm._s(_vm.calendarsExclArchived.length))]), _vm._v(" "), (_vm.selectedCalIds.length < 1) ? _c('button', {
    staticClass: "bttn--disabled hint--bottom-left",
    attrs: {
      "aria-label": this.$t('vue2.calendars.select_calendars_to_copy')
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.copy')) + "\n          ")]) : _c('CopyButton', {
    attrs: {
      "calType": _vm.calType
    },
    on: {
      "open": function($event) {
        _vm.isCopyOpen = true
      },
      "close": function($event) {
        _vm.isCopyOpen = false
      },
      "submit": function($event) {
        return _vm.copyCals($event)
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.calendarsExclArchived), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "d-copy-cals__cal",
      class: {
        'd-copy-cals__cal--selected': _vm.getIsInSelectedCalIds(calendar.id)
      },
      on: {
        "click": function($event) {
          return _vm.toogleCal(calendar.id)
        }
      }
    }, [_vm._m(0, true), _vm._v("\n        " + _vm._s(calendar.name) + "\n      ")])
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-copy-cals__cal__selector"
  }, [_c('div', {
    staticClass: "checkbox"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e3bd68b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyCalendar/CopyMultipleCalendars.vue
// module id = 1537
// module chunks = 1